import { storage } from '@rehooks/local-storage/lib/storage';
const openedInIFrame = window !== window.top;

const FINGER_PRINT_KEY = 'browserFingerprint';

function getBrowserInfo(): string {
  const { userAgent, vendor, cookieEnabled, language, hardwareConcurrency } = navigator;

  const info: (boolean | number | string)[] = [userAgent, vendor, cookieEnabled, language, hardwareConcurrency];

  return info.join(',');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function generateFingerprint(md5: any) {
  const fingerprint = md5.default(getBrowserInfo());
  storage.setItem(FINGER_PRINT_KEY, fingerprint);

  return fingerprint;
}

function getBrowserFingerprint(): Promise<string> {
  const fingerprint = storage.getItem(FINGER_PRINT_KEY) || '';

  if (!openedInIFrame && fingerprint && fingerprint.length === 32) {
    return Promise.resolve(fingerprint);
  } else {
    return new Promise((resolve, reject) => {
      import('js-md5').then(generateFingerprint).then(resolve).catch(reject);
    });
  }
}

export { getBrowserFingerprint };
